// @flow
import React from 'react';

import { updateOeuvreExpo, createOeuvreExpoUpdateExpo } from 'Api';
import ExpoOeuvreForm from 'pages/Avila/ExpoOeuvre/Form'

import FormModal from './FormModal'
import { useTranslation } from 'react-i18next'

type Props = {
    expoId: any,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any
}
export default ({
    onClose,
    actions = [],
    data,
    expoId,
    expo,
    isMultiple = false,
    onSave = () => {}
}: Props) => {
    
    const { t } = useTranslation();

    return (

        <FormModal
            title={t("oeuvre")}
            data={data}
            onClose={onClose}
            isMultiple={isMultiple}
            FormComponent={ExpoOeuvreForm}

            onSave={onSave}
            updateMethod={({ data }) => updateOeuvreExpo({ expoId, data })}
            createMethod={({ data }) => createOeuvreExpoUpdateExpo({ expo, data })}
        />
    )
}